import { Component, Prop, Vue } from 'vue-property-decorator';
import template from './Linear.vue';

@Component({
	mixins: [template]
})
export default class LinearStatistic extends Vue {
	@Prop() title!: string;

	@Prop() description!: string;

	@Prop() hint!: string;

	@Prop() current!: number;

	@Prop() max!: number;

	get percentageValue() {
		const self = this;

		if (self.max === -1) {
			return -1;
		}
		return Math.round(((self.current || 0) / (self.max || 100)) * 100);
	}
}
